import React, { useEffect, useState } from 'react';
import api from '../../api';
import AdminSectionHeader from '../../components/admin/AdminSectionHeader';
import StatusMessage from '../../components/admin/StatusMessage';

export default function CommentsPage() {
  const [pendingComments, setPendingComments] = useState([]);
  const [msg, setMsg] = useState({ type: '', text: '' });

  useEffect(() => {
    loadComments();
  }, []);

  const loadComments = () => {
    api.get('/api/admin/comments/pending')
      .then((r) => setPendingComments(r.data || []))
      .catch(() => setMsg({ type: 'error', text: 'Failed to load pending comments' }));
  };

  const showMsg = (type, text, duration = 3000) => {
    setMsg({ type, text });
    setTimeout(() => setMsg({ type: '', text: '' }), duration);
  };

  const approveComment = async (id) => {
    try {
      await api.post(`/api/admin/comments/${id}/approve`);
      setPendingComments((c) => c.filter((x) => x.id !== id));
      showMsg('success', 'Comment approved');
    } catch {
      showMsg('error', 'Failed to approve comment');
    }
  };

  const rejectComment = async (id) => {
    const reason = window.prompt('Enter rejection reason (optional):', '');
    try {
      await api.post(`/api/admin/comments/${id}/reject`, { reason });
      setPendingComments((c) => c.filter((x) => x.id !== id));
      showMsg('success', 'Comment rejected');
    } catch {
      showMsg('error', 'Failed to reject comment');
    }
  };

  return (
    <div className="admin-comments-page">
      <AdminSectionHeader
        title="Review Comments"
        subtitle="Moderate pending comments"
      />

      {msg.text && <StatusMessage type={msg.type} message={msg.text} />}

      {pendingComments.length === 0 ? (
        <p className="empty-state">No pending comments to review.</p>
      ) : (
        <ul className="comments-list">
          {pendingComments.map((c) => (
            <li key={c.id} className="comment-item">
              <div className="comment-info">
                <h5>{c.author_name}</h5>
                <div className="comment-meta">
                  <small>{c.message.substring(0, 150)}...</small>
                  <small>{new Date(c.created_at).toLocaleString()}</small>
                </div>
              </div>
              <div className="comment-actions">
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={() => approveComment(c.id)}
                  title="Approve"
                >
                  <i className="fa-solid fa-check"></i> Approve
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => rejectComment(c.id)}
                  title="Reject"
                >
                  <i className="fa-solid fa-xmark"></i> Reject
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}